module.exports = __webpack_public_path__ + "static/icons/icon-check-circle-672ef742e178882edd02c4bc846b71c4.svg";